export default __webpack_public_path__ + "static/media/failed.61ba96f6.png";